export default {
domainInvalid: {
  siteUnavailableTitle: "サイトを利用できません",
  siteUnavailableDesc: "現在このサイトはご利用いただけません。",
  contactAdmin: "管理者にお問い合わせください。",
  serverErrorTitle: "サービスを利用できません",
  serverErrorDesc: "サーバーに接続できませんでした。しばらくしてから再度お試しください。",
  serverErrorTip: "サーバーが復旧すると自動的に再接続されます。",
  notAuthorizedTitle: "ドメインが承認されていません",
  notAuthorizedDesc: "現在のドメインはこのサービスへのアクセスを承認されていません。",
  checking: "確認中...",
  retry: "再試行",
  reload: "再読み込み",
  reloading: "再読み込み中...",
  checkingDomain: "ドメインを確認中...",
  authorizedRedirecting: "ドメインが承認されました。リダイレクトしています...",
  stillNotAuthorized: "ドメインはまだ承認されていません",
  reconnecting: "再接続中..."
}
};
